export const truncateBreadcrumbs = (text: string | null): string => {
	const charLimit = 20;
	if (text === null) {
		return '';
	}

	return text.length > charLimit ? `${text.slice(0, charLimit)}...` : text;
};
